import { FormGroup, FormControlLabel, Checkbox } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import type { ChangeEvent } from "react";
import type { EditableCheckboxes, EditableListing } from "../../../../../@types/listings/new";

type ListingDialogCheckboxesProps = {
  loading: boolean;
  editableFormColumns: EditableListing;
  handleChangeChecked: (event: ChangeEvent<HTMLInputElement>) => void;
};

export function ListingDialogInputCheckboxes({
  loading,
  editableFormColumns,
  handleChangeChecked
}: ListingDialogCheckboxesProps): JSX.Element {
  const { t: translate } = useTranslation();

  return (
    <FormGroup row>
      {editableCheckboxes.map((checkboxId) => {
        const label = translate(`listingsPage.tableColumns.${checkboxId}`);
        const value = editableFormColumns[checkboxId];

        return (
          <FormControlLabel
            disabled={loading}
            control={
              <Checkbox name={checkboxId} checked={Boolean(value)} onChange={handleChangeChecked} />
            }
            label={label}
            key={checkboxId}
          />
        );
      })}
    </FormGroup>
  );
}

const editableCheckboxes: EditableCheckboxes[] = [
  "hasGarden",
  "hasParking",
  "hasElevator",
  "hasStorage",
  "hasTerrace",
  "hasBars",
  "hasAirConditioning",
  "housingUnit",
  // ממ"ד, ממ"ק and מקלט are three independent facts about a listing, so they are three plain
  // adjacent checkboxes. The boxed "מרחב מוגן" group with its "any of these" hint belongs to
  // the buyer / filter side only.
  "protectedSpace",
  "hasMamak",
  "hasMiklat",
  "accessibleForDisabled"
];
